import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const addDocsOrgToDoc = async ({ docId, clientName }) => {
  return await request.post(
    `/Docs/counterparty_owner`,
    { id: docId, name: clientName },
    'При изменении добавлении адресата произошла ошибка документа произошла ошибка',
    'Error'
  );
};

const useAddDocsCounterpartyOwner = () => {
  const mutation = useMutation(addDocsOrgToDoc, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocsCounterpartyOwnerc: mutation.isLoading,
    addDocsCounterpartyOwner: mutation.mutateAsync,
  };
};

export default useAddDocsCounterpartyOwner;
